module.exports = __webpack_public_path__ + "static/img/company2.d13331d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/company2.png
// module id = SULZ
// module chunks = 0